/**
 * @generated SignedSource<<035a3ce8c3cbd8c3ab1ae1988e93b90f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CatalogPageNumber_catalogPage$data = {
  readonly images: {
    readonly pageCount: number | null;
    readonly singlePageDimensions: {
      readonly height: number;
      readonly width: number;
    };
  } | null;
  readonly " $fragmentType": "CatalogPageNumber_catalogPage";
};
export type CatalogPageNumber_catalogPage$key = {
  readonly " $data"?: CatalogPageNumber_catalogPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"CatalogPageNumber_catalogPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CatalogPageNumber_catalogPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CatalogImagesType",
      "kind": "LinkedField",
      "name": "images",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pageCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CatalogImagesDimensions",
          "kind": "LinkedField",
          "name": "singlePageDimensions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CatalogPage",
  "abstractKey": null
};

(node as any).hash = "e35794794bb210925dd983d495d79c4c";

export default node;
